import {moment} from 'helpers';
import {format} from '../decode/convert';

export function journals(record) {
  return {
    body: record.text,
    date: record.date ? moment.unix(record.date).format(format) : '',
    goalId: record.goalId,
    serverId: record.id,
    subject: record.subject,
    tagIds: record.tagIds,
    taskId: record.taskId,
    time: record.time,
  }
}
